module.exports = __webpack_public_path__ + "static/media/harvard.c271adde.png";